import { post } from '@/request';

const orgApi = {
  list(data) {
    return post('/nfm/org/zlb/list', data);
  },
  pickerList(data) {
    return post('/nfm/org/zlb/pickerList', data);
  }
};
export default orgApi;
